export default __webpack_public_path__ + "static/media/regulatory--priority-over-oncoming-vehicles--g2.7de31d11.png";